import { clearCookie, setCookie } from "../../utilities/cookies";
import { AUTH_COOKIE_KEYS, AUTH_STORAGE_KEYS } from "./authConstants";

export function readStoredUser() {
  try {
    const value = localStorage.getItem("user");
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
}

export function persistIdentitySession({ user, accessToken, refreshToken, sessionToken }) {
  const normalizedAccessToken = accessToken || user?.accessToken || user?.token || "";
  const normalizedRefreshToken = refreshToken || user?.refreshToken || "";
  const normalizedSessionToken = sessionToken || user?.sessionToken || "";
  const normalizedUser = {
    ...(user || {}),
    ...(normalizedAccessToken ? { accessToken: normalizedAccessToken, token: normalizedAccessToken } : {}),
    ...(normalizedRefreshToken ? { refreshToken: normalizedRefreshToken } : {}),
    ...(normalizedSessionToken ? { sessionToken: normalizedSessionToken } : {}),
  };

  localStorage.setItem("user", JSON.stringify(normalizedUser));
  if (normalizedAccessToken) localStorage.setItem("token", normalizedAccessToken);
  else localStorage.removeItem("token");
  if (normalizedRefreshToken) localStorage.setItem("refreshToken", normalizedRefreshToken);
  else localStorage.removeItem("refreshToken");
  if (normalizedSessionToken) localStorage.setItem("sessionToken", normalizedSessionToken);
  else localStorage.removeItem("sessionToken");

  const userId = normalizedUser?._id || normalizedUser?.id || "";
  const fullName = normalizedUser?.username || [normalizedUser?.firstName, normalizedUser?.lastName].filter(Boolean).join(" ");
  if (userId) setCookie("userId", userId);
  if (fullName) setCookie("fullName", fullName);
  if (normalizedUser?.role) setCookie("role", normalizedUser.role);
  if (normalizedAccessToken) setCookie("accessToken", normalizedAccessToken);
  if (normalizedRefreshToken) setCookie("refreshToken", normalizedRefreshToken);
  return normalizedUser;
}

export function clearIdentitySession({ preserve = ["pendingInvitationToken", "selectedOrganization"] } = {}) {
  const preserved = Object.fromEntries(
    preserve.map((key) => [key, localStorage.getItem(key)]).filter(([, value]) => value !== null)
  );
  AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
  AUTH_COOKIE_KEYS.forEach((key) => clearCookie(key));
  Object.entries(preserved).forEach(([key, value]) => localStorage.setItem(key, value));
}
